import Logger from '@/lib/logger';
import { NEXT_PUBLIC_GROWTHBOOK_LOGGING_ENABLED } from '@/lib/env';

const logger = new Logger('GrowthBook', 'DEBUG');

if (NEXT_PUBLIC_GROWTHBOOK_LOGGING_ENABLED) {
  logger.enable();
}

export default logger;
